import { Action } from '@ngrx/store';
import { LoginRequestInterface } from '../../models/login-request.interface';
import { LoginResponseInterface } from '../../models/login-response.interface';

export enum ELoginActions {
  GetToken = '[LOGIN] Get token',
  GetTokenSuccess = '[LOGIN] Get token success',
  GetTokenFailure = '[LOGIN] Get token failure',
  DeleteToken = '[LOGIN] Delete token',
  DeleteTokenSuccess = '[LOGIN] Delete token success',
}

export class GetToken implements Action {
  public readonly type = ELoginActions.GetToken;
  constructor(public payload: LoginRequestInterface) {}
}

export class GetTokenSuccess implements Action {
  public readonly type = ELoginActions.GetTokenSuccess;
  constructor(public payload: LoginResponseInterface|{customerId: string}) {}
}

export class GetTokenFailure implements Action {
  public readonly type = ELoginActions.GetTokenFailure;
}

export class DeleteToken implements Action {
  public readonly type = ELoginActions.DeleteToken;
}

export class DeleteTokenSuccess implements Action {
  public readonly type = ELoginActions.DeleteTokenSuccess;
}

export type LoginActions = GetToken | GetTokenSuccess | GetTokenFailure | DeleteToken | DeleteTokenSuccess;
